import ActiveFast from './active_fast.png';
import ActiveSlow from './active_slow.png';
import Add from './add.png';
import Bottom from './bottom.png';
import Clean from './clean.png';
import Delete from './delete.png';
import Double from './double.png';
import Down from './down.png';
import Fast from './fast.png';
import Focus from './focus.png';
import Left from './left.png';
import Replace from './replacement.png';
import Right from './right.png';
import RotateLeft from './rotate_left.png';
import RotateRight from './rotate_right.png';
import Save from './save.png';
import Slow from './slow.png';
import Top from './top.png';
import Up from './up.png';
import MirrorX from './mirror_x.png';
import MirrorY from './mirror_y.png';
import MirrorZ from './mirror_z.png';

const index = {
    ActiveFast,
    ActiveSlow,
    Add,
    Bottom,
    Clean,
    Delete,
    Double,
    Down,
    Fast,
    Focus,
    Left,
    Replace,
    Right,
    RotateLeft,
    RotateRight,
    Save,
    Slow,
    Top,
    Up,
    MirrorX,
    MirrorY,
    MirrorZ
};

export default index;